import VSelectIntegralActivity from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectIntegralActivity', VSelectIntegralActivity),
};
